import { Avatar, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import { Chat } from './chat';

interface ChatItemProps {
    chat: Chat;
    onClick: (chat: Chat) => void;
}

export default function ChatItem({ chat, onClick }: ChatItemProps) {
    const initial = chat.nome_cliente_message.charAt(0).toUpperCase();

    return (
        <ListItem
            button
            onClick={() => onClick(chat)}
            sx={{
                '&:hover': {
                    backgroundColor: 'action.hover'
                }
            }}
        >
            <ListItemAvatar>
                <Avatar sx={{ bgcolor: 'primary.main' }}>{initial}</Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={
                    <Typography
                        component="div"
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <Typography variant="subtitle1" component="span">
                            {chat.nome_cliente_message}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {chat.message_at}
                        </Typography>
                    </Typography>
                }
                secondary={`${chat.causa_processo_message} | ${chat.status_processo_message}`}
            />
        </ListItem>
    );
}